export default {
  lightestGray: "#F9F8FB",
  lightGray: "#F0EEF5",
  midGray: "#D7D5E0",
  darkGray: "#75728E",
  navy: "#222A5C",
  blue: "#169EFF",
  darkBlue: "#0074DF",
  red: "#DB3649",
  green: "#00A876",
  darkGreen: "#008464"
};
